import React from 'react';
import {Box, Grid, Button} from '@material-ui/core';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import DialogHelp from '../components/DialogHelp';
import { LoadingButton } from '@mui/lab';
import LinearProgress from '@mui/material/LinearProgress';
import DialogFeedback from '../components/DialogFeedback';
import SaveIcon from '@mui/icons-material/Save';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { MathJaxContext } from "better-react-mathjax";
import '../styles/bizofficer.css';
import {API_URL} from '../utils/EnvVars';
import 'font-awesome/css/font-awesome.min.css';

  //English Sec I
  ///sectionLock = No_Lock,Partially_Lock,Complete_Lock

  const config = {
	/* in theory, the MathML input processor should be activated if we add
	an "mml" block to the config OR if "input/mml" (NOT "input/mathml" as stated 
	in the docs) is in the load array. However, this is not necessary as MathML is 
	ALWAYS enabled in MathJax */
	loader: { load: ["input/mml", "output/chtml"] },
	mml: {}
  };

  export default function Execute() { 
	var etlStudentObj = JSON.parse(localStorage.getItem('etlStudentObj'));
	const openHelpRef = React.useRef();
	const [loadingPage, setLoadingPage] = React.useState(true);
	const [finishTestLoading, setFinishTestLoading] = React.useState(false);
	const [testSet, setTestSet] = React.useState([]); 
	const [currentQuestionObj, setCurrentQuestionObj] = React.useState({});
	const [currentQuestion, setCurrentQuestion] = React.useState(0);
	const [totalQuestion, setTotalQuestion] = React.useState(0);
	// const [notVisitedTotal, setNotVisitedTotal] = React.useState(0);
	// const [notAnsweredTotal, setNotAnsweredTotal] = React.useState(0);
	// const [answeredTotal, setAnsweredTotal] = React.useState(0);
	
	const authResult = new URLSearchParams(window.location.search); 
	const testId = authResult.get('testId');

	const deviceType = authResult.get('device_type');
  	if(deviceType && deviceType.length>0){
    	localStorage.setItem("deviceType", deviceType);
  	}
	
	var totalWeightage = 0;
	var qqqPartMarks = 0;

	// check if logged in
	if(localStorage.getItem('etlStudentObj')===null){
		window.location.href='login';
	}

	
	// function checkedAnswers(num){
	// 	let questionId = testSet[0].questionSet[num].questionId;
	// 	let checkedAns=[];
	// 	if(testSet[0].questionSet[num].questionType=="Fill-In-Blank"){
	// 		if(document.getElementById("ans"+questionId+"a").value && document.getElementById("ans"+questionId+"a").value.length>0){
	// 			checkedAns.push(document.getElementById("ans"+questionId+"a").value);
	// 		}
	// 	}else if(testSet[0].questionSet[num].questionType=="MR-Matching-Type" || testSet[0].questionSet[num].questionType=="Matching-Type"){
	// 		let totalOptions = Object.keys(testSet[0].questionSet[num].columns[0].columnRows).length;
	// 		totalOptions = totalOptions*totalOptions;
	// 		for(let i=1; i<=totalOptions; i++ ){
	// 			if(document.getElementById("ans"+questionId+"a"+i) && document.getElementById("ans"+questionId+"a"+i).checked==true){
	// 				checkedAns.push(document.getElementById("ans"+questionId+"a"+i).value)
	// 			}	
	// 		}

	// 	}else{
	// 		let totalOptions = Object.keys(testSet[0].questionSet[num].responseChoice).length;
	// 		for(let i=0; i<totalOptions; i++ ){
	// 			if(document.getElementById("ans"+questionId+"a"+i) && document.getElementById("ans"+questionId+"a"+i).checked==true){
	// 				checkedAns.push(document.getElementById("ans"+questionId+"a"+i).value)
	// 			}	
	// 		}

	// 	}
	// 	return checkedAns;		
	// }
	
	// function mrResponse(num){
	// 	let questionId = testSet[0].questionSet[num].questionId;
	// 	let checkedAns=[];
	// 	checkedAns=checkedAnswers(num);
	// 	if(checkedAns.length){
	// 		document.getElementById('ans'+questionId).innerHTML=checkedAns.join(",");
	// 		document.getElementById('btn'+questionId).classList.remove("qbg-not-visited");
	// 		document.getElementById('btn'+questionId).classList.add("qbg-visited");
	// 		if(document.getElementById('btn'+questionId).style.background.indexOf('answered-review.png')>-1){
	// 		}else if(document.getElementById('btn'+questionId).style.background.indexOf('review.png')>-1){
	// 			document.getElementById('btn'+questionId).style.background="url('"+process.env.PUBLIC_URL+"/answered-review.png')";	
	// 		}else{
	// 			document.getElementById('btn'+questionId).style.background="url('"+process.env.PUBLIC_URL+"/answered.png')";
	// 		}	
	// 	}else{
	// 		document.getElementById('ans'+questionId).innerHTML="";
	// 		document.getElementById('btn'+questionId).classList.remove("qbg-not-visited");
	// 		document.getElementById('btn'+questionId).classList.add("qbg-visited");
	// 		if(document.getElementById('btn'+questionId).style.background.indexOf('answered-review.png')>-1){
	// 			document.getElementById('btn'+questionId).style.background="url('"+process.env.PUBLIC_URL+"/review.png')";
	// 		}else if(document.getElementById('btn'+questionId).style.background.indexOf('review.png')>-1){	
	// 		}else{
	// 			document.getElementById('btn'+questionId).style.background="url('"+process.env.PUBLIC_URL+"/not-answered.png')";
	// 		}
	// 	}		
	// }

	// function uncheckHandle(chkId){
	// 	if(document.getElementById("hidetxt"+chkId).value==1){
	// 		document.getElementById(chkId).checked=false;
	// 		document.getElementById("hidetxt"+chkId).value="";
	// 	}else if(document.getElementById(chkId).checked==true){
	// 		let totalOptions = Object.keys(testSet[0].questionSet[currentQuestion].responseChoice).length;
	// 		let questionId = testSet[0].questionSet[currentQuestion].questionId;
	// 		for(let i=0; i<totalOptions; i++ ){
	// 			document.getElementById("hidetxtans"+questionId+"a"+i).value="";
	// 		}
	// 		document.getElementById("hidetxt"+chkId).value=1;
	// 	} 
	// 	mrResponse(currentQuestion);
	// }
	function backHandle(){
		currentQuestion==0?jumpToQuestion(0):jumpToQuestion(currentQuestion-1);
	}
	function nextHandle(){
		if(totalQuestion==(currentQuestion+1)){
			jumpToQuestion(0);
		}else{
			currentQuestion==(totalQuestion-1)?jumpToQuestion(currentQuestion):jumpToQuestion(currentQuestion+1);
		}	

		if(testSet[0].testStatus!==1){
			postApiDataUpdateMarks(0);
		}

	}	
	function changeCurrentQuestion(num){
		document.getElementById('questionBox'+currentQuestion).style.display="none";
		document.getElementById('questionBox'+num).style.display="";
		setCurrentQuestion(num);
		setCurrentQuestionObj(testSet[0].questionSet[num]);
	}
	function jumpToQuestion(num){
		if(num!=currentQuestion){
			changeCurrentQuestion(num);
		}
	}
	function backToReports(){ 
		window.location.href='report';
	}
	

	React.useEffect(() => {
		getApiData();	
	}, []); 

	async function getApiData(){
		
		let axiosHeader = {
			headers: {
				'Content-Type': 'multipart/mixed',
				'loginId': etlStudentObj.loginId,
				'token': etlStudentObj.token,
				'device': 'web'
			}
		};

		axios.get(API_URL+'/testresultview?testSession='+testId, axiosHeader)
			   .then(response => {
				setLoadingPage(false);
				//document.write(JSON.stringify(response.data));  
				if(response.data!=null && response.data[0]!=null){

					setTestSet(response.data);						

					const apiResponseData = response.data ;


					if(apiResponseData[0] && apiResponseData[0].questionSet){						
						setCurrentQuestionObj(apiResponseData[0].questionSet[0]);
						if(document.getElementById('questionBox'+currentQuestion)){
							document.getElementById('questionBox'+currentQuestion).style.display="";
						}
						setTotalQuestion(Object.keys(apiResponseData[0].questionSet).length);
						if(document.getElementById('notVisitedTotalDivId')){
							document.getElementById('notVisitedTotalDivId').innerHTML=Object.keys(apiResponseData[0].questionSet).length;
						}

						let studentResponseArr = [];
						for(let i=0; i<apiResponseData[0].questionSet.length; i++){
							
							let marksTxt = document.getElementById('marks'+apiResponseData[0].questionSet[i].questionId);

							if(apiResponseData[0].questionSet[i].studentResponse && apiResponseData[0].questionSet[i].studentResponse.length>0){
								studentResponseArr = apiResponseData[0].questionSet[i].studentResponse.split("$$$$$");
								document.getElementById("ans"+apiResponseData[0].questionSet[i].questionId).innerHTML=studentResponseArr[0];
								document.getElementById("iframe"+apiResponseData[0].questionSet[i].questionId).src=studentResponseArr[2];

								if(apiResponseData[0].questionSet[i].marks>0 && marksTxt){
									marksTxt.value=apiResponseData[0].questionSet[i].marks;
								}else if(marksTxt){
									marksTxt.value=0;
								}
							}else if(apiResponseData[0].questionSet[i].marks>0 && marksTxt){
								marksTxt.value=apiResponseData[0].questionSet[i].marks;
							}else if(marksTxt){
								marksTxt.value=0;
							}
							
							if(apiResponseData[0].questionSet[i].correctResponse && apiResponseData[0].questionSet[i].correctResponse.length>0){
								let correctResponseArr = JSON.parse(apiResponseData[0].questionSet[i].correctResponse);
								for(let k=0; k<correctResponseArr.length; k++){
									let chkBox = document.getElementById("option"+apiResponseData[0].questionSet[i].questionId+"a"+k);
									if(correctResponseArr[k].status===1 && chkBox){
										chkBox.checked=true;
									}else if(chkBox){
										chkBox.checked=false;
									}
								}
							}

						}
					}
				}					
			}).catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})
	}

	async function postApiDataUpdateMarks(opt){

		if(testId){	

			let testtId = testId.substring(2,testId.length);
			let qid = testSet[0].questionSet[currentQuestion].questionId;

			let correctResponseArr = [];
			if(testSet && testSet[0].questionSet && testSet[0].questionSet[currentQuestion] && testSet[0].questionSet[currentQuestion].correctResponse){				
				let correctResponseList = JSON.parse(testSet[0].questionSet[currentQuestion].correctResponse);
				let status = 0;
				for(let i=0; i<correctResponseList.length; i++){
					if(document.getElementById('option'+qid+'a'+i).checked===true){
						status = 1;
					}else{
						status = 0;
					} 				
					let item = {"mattext":correctResponseList[i].mattext,"partMarks":correctResponseList[i].partMarks,"status":status}; 
					correctResponseArr.push(item);
				}
			}

			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'loginId': etlStudentObj.loginId,
					'token': etlStudentObj.token,
					'device': 'web'
				}
			};

			let qmarks = 0, marksoption='';
			if(document.getElementById('marks'+qid) && document.getElementById('marks'+qid).value>=0.5){
				qmarks = document.getElementById('marks'+qid).value;
			}
			if(document.getElementById('markoption'+qid)){
				marksoption = document.getElementById('markoption'+qid).value;
			}

			const data = new FormData();
			data.append('testSession', testtId);
			data.append('questionId', qid);
			data.append('marks', qmarks);
			data.append('marksoption', marksoption);
			data.append('finishTest', opt);

			if(correctResponseArr && correctResponseArr.length>0){
				data.append('correctResponse', JSON.stringify(correctResponseArr));
			}else{
				data.append('correctResponse', '');
			}

			
			
			axios.post(API_URL+'/updatemarks-test', data, axiosHeader)
				.then(response => {
					// console.log("Just Checking >> "+JSON.stringify(response.data));  
					if(response && response.status===200 && response.data && response.data.responseTxt==='success'){
						if(opt===1){ window.location.href='report'; }
					}					
				}).catch((error) => {
					alert(error);
					///console.log("ERROR: ", error);
				})

		}

	}

	function finishTest() {
		setFinishTestLoading(true);	
		postApiDataUpdateMarks(1);	
	}

    // function openTopNav(divid) {
	// 	document.getElementById(divid).style.width = "250px";
	// 	document.getElementById('timingBoxId').classList.add("testTimingBoxLeft");
	// 	document.getElementById('timingBoxId').classList.remove("testTimingBox");
	// 	document.getElementById('questionPanelId').classList.remove("questionPanelFull");
	// 	document.getElementById('questionPanelId').classList.add("questionPanelShort");
	// }
	  
	function closeTopNav(divid) {
		document.getElementById(divid).style.width = "0";
		document.getElementById('timingBoxId').classList.remove("testTimingBoxLeft");
		document.getElementById('timingBoxId').classList.add("testTimingBox");
		document.getElementById('questionPanelId').classList.add("questionPanelFull");
		document.getElementById('questionPanelId').classList.remove("questionPanelShort");
	}

	function openHelp(){
		openHelpRef.current.handleClickOpen();
	}


	  
	// function convertToArray(str){
	// 	let retArr = [];
	// 	if(str.length>0){
	// 		let strArr = str.split("<math");
	// 		for(let i=0; i<strArr.length; i++){
	// 			if(strArr[i].indexOf("</math>")>-1 && strArr[i].indexOf("xmlns=")>-1){
	// 				let strZArr = strArr[i].split("</math>");
	// 				if(strZArr[0] && strZArr[0].indexOf("xmlns=")>-1){
	// 					retArr.push("<math "+strZArr[0].trim().replace(/[\r\n]+/g, '')+"</math>");
	// 				}
	// 				if(strZArr[1]){
	// 					retArr.push(strZArr[1].trim().replace(/[\r\n]+/g, ''));
	// 				}
	// 			}else{
	// 				retArr.push(strArr[i].trim().replace(/[\r\n]+/g, ''));
	// 			}
	// 		}
	// 	}

	// 	return retArr;
	// }

  /* RIGHT CLICK DISABLED ON THIS COMPONENT */
  document.addEventListener("contextmenu", (event) => {
	event.preventDefault();
  });

  /* CTRL KEY DISABLED ON THIS COMPONENT */
  document.addEventListener("keydown", function (event) {
    if (event.ctrlKey) {
        event.preventDefault();
    }   
  });

  /* REFRESH PAGE DISABLED ON THIS COMPONENT */
  if (window.performance) {
	if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
		document.addEventListener("keydown", function (event) {
			if ((event.which || event.keyCode) == 116 || (event.which || event.keyCode) == 17 || ((event.which || event.keyCode) == 82 )) {
				// Pressing F5 or Ctrl+R
				event.preventDefault();
			}   
		  });  
	} 
  }

  function onBodyClickAction() {
	if(window.screen.width<480){
	  closeTopNav('mySidepanel');
	}
  }
  
  function giveMarks(qid,correctAnsMarks,prtMarksId) {	
	let prtMarksTxtId = document.getElementById(prtMarksId);
	let qmarksTxt = document.getElementById('marks'+qid);
	let marksOptionTxt = document.getElementById('markoption'+qid);
	if(prtMarksTxtId && qmarksTxt){		

		let responseChoices = testSet[0].questionSet[currentQuestion].responseChoice;
		let tot=0, marksOption=[];
		if(responseChoices && responseChoices.length>0){
			let i=0;
			for(i=0; i<responseChoices.length; i++){
				if(document.getElementById('option'+qid+"a"+i).checked===true){					
					tot+=parseFloat(document.getElementById('partmarks'+qid+"a"+i).value);
					marksOption.push('yes');
				}else{
					marksOption.push('no');
				}
			}			
		}		
		qmarksTxt.value = Number(tot).toFixed(2);
		if(marksOption && marksOption.length>0){
			marksOptionTxt.value = marksOption.join(',');		
		}

		if(qmarksTxt.value>correctAnsMarks){
			qmarksTxt.value=correctAnsMarks;
		}else if(qmarksTxt.value<correctAnsMarks){
			let diffVal = correctAnsMarks - qmarksTxt.value;
			if(diffVal<0.11 && qmarksTxt.value>0.89){
			   qmarksTxt.value=correctAnsMarks;
			}else if(qmarksTxt.value<0.02){
				qmarksTxt.value=0;
			}
		}

	}

  }

  function print() {
	let content = document.getElementById("printcontents");
	if(content){
		let pri = document.getElementById("ifmcontentstoprint").contentWindow;
		pri.document.open();
		pri.document.write(content.innerHTML);
		pri.document.close();
		pri.focus();
		pri.print();
	}
  }

  function chkOption(qid){	
	if(document.getElementById('markoption'+qid) && document.getElementById('markoption'+qid).value.trim().length>0){
		let marksOptionArr = document.getElementById('markoption'+qid).value.split(',');
		let responseChoices = testSet[0].questionSet[currentQuestion].responseChoice;		
		if(responseChoices && responseChoices.length>0){
			let i=0;
			for(i=0; i<responseChoices.length; i++){
				if(marksOptionArr[i]=='yes' && document.getElementById('option'+qid+"a"+i)){					
					document.getElementById('option'+qid+"a"+i).checked=true;
				}else if(document.getElementById('option'+qid+"a"+i)){
					document.getElementById('option'+qid+"a"+i).checked=false;
				}
			}			
		}		
	}		
  }

  function chkedIcon(i,qid){
	let opt=0;	
	if(document.getElementById('markoption'+qid) && document.getElementById('markoption'+qid).value.trim().length>0){
		let marksOptionArr = document.getElementById('markoption'+qid).value.split(',');
		if(marksOptionArr[i]=='yes'){					
			opt=1;
		}	
	}	
	return opt;		
  }

	return (
			<div> 
				<MetaTags>
            		<title>Subjective Test Marking</title>
            		<meta name="description" content="Subjective Test Marking" />
          		</MetaTags>
				  {!window.navigator.onLine?
    <div className='netBar' >Alert: It seems, you are not connected to the internet.</div>
    :null}
				<Box style={{marginBottom:100, marginLeft:20, marginRight:20}}>					
				{loadingPage?<LinearProgress />:null}	

	{(testSet[0] && testSet[0]!=null && testSet[0].questionSet)?<>		
				<Box mt={1} className="noselect" >
						<Grid container spacing={2}>
							<Grid item md={12} xs={12}>
							{testSet[0]?<span className='test-name' >{testSet[0].testName}</span>:null}
							</Grid>	
							<Grid id="timingBoxId" item md={6} xs={12} className='testTimingBoxLeft' ></Grid>						
						</Grid>
				</Box>

		{(testSet[0] && testSet[0].questionSet)?	
		<Box id="questionPanelId" onClick={()=>{onBodyClickAction()}} >	
		{testSet[0].questionSet.map((myQuestion,myqnum) => (
				<Box key={'qes'+myqnum} className="noselect" id={'questionBox'+myqnum} style={{display:'none'}}  >
						<Box spacing={2}>
						<Grid container spacing={2} >
							<Grid item md={12} xs={12} >
								{myQuestion.sectionName?<div className='taglabelblu mr5' >Section: {myQuestion.sectionName}</div>:null}
								<div className='taglabelblu mr5' >Question Type: {myQuestion.questionTypeLabel}</div>
								<div className='taglabelblu mr5' >Question Id: {myQuestion.questionDisplayId}</div>
							</Grid>
							<Grid item md={12} xs={12} className="questionBox" >
								{(myQuestion.commonDataDescription && myQuestion.commonDataDescription.length>0)?<p className="preWrap animate-zoom" >
									{
										 <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.commonDataDescription.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
									}
								</p>:null}
								<p className="preWrap animate-zoom" >
								<span className="questionNum" >Question {myqnum+1}: </span> 
								{(myQuestion.questionBody && myQuestion.questionBody.length>0)?<span>
									{
										 <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.questionBody.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
									}
								</span>:null}										
								</p>
								{
									myQuestion.columns?
									<p className="animate-zoom">
										<table width="100%">
											<tr>
												{
													myQuestion.columns.map((myRow,index) => (	
														<td className="btmbdrgry pdlft10"><h3>{myRow.columnHeader}</h3></td>
													))		
  												}
											</tr>	
												<tr>
												{myQuestion.columns.map((myCol,indexCol) => (
													<td><table width="100%">{
														myCol.columnRows.map((myRow,indexrrr) => (
															<tr>
															<td key={'crwq'+indexrrr+'dd'+indexCol} className="btmbdrgry pdlft10 content-justify preWrap" >
																{myRow.rowId}.&nbsp;
																{(myRow.rowName && myRow.rowName.length>0)?
																	 <MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.rowName.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
																 :null														
																}
																</td>
															</tr>
														))
  														}</table>
													</td>
												))}
												</tr>
										</table>
									</p>
									:null
								}

							</Grid>
						</Grid>
						</Box>

						<Box className="animate-zoom" >
									<Grid container spacing={2} >
										<Grid item md={6} sm={12} xs={12} style={{border: '2px solid gray'}} >
											<h3 style={{textAlign:'center',borderBottom: '2px solid gray',color:'#1572e8'}} >
												Your Answer {testSet[0].testStatus===1?
												<span style={{color:'#764abc',fontWeight:'bold',fontSize:18}}>{myQuestion.marks}</span>
												:<input type="text" id={"marks"+myQuestion.questionId} style={{width:50, color:'#ff1919',fontWeight:'bold',fontSize:18}} />} / {myQuestion.correctAnswerMarks}</h3>
												<input type="hidden" id={"markoption"+myQuestion.questionId} value={myQuestion.answerStatus} />
												<span hidden >{chkOption(myQuestion.questionId)}</span>	
											<div id={"ans"+myQuestion.questionId}></div>
											<div>
												<iframe id={"iframe"+myQuestion.questionId} style={{width:'100%',minHeight: 400}}  src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
											</div>
										</Grid>
										<Grid item  md={6} sm={12} xs={12} style={{border: '2px solid gray'}} >
											<h3 style={{textAlign:'center',borderBottom: '2px solid gray',color:'#1572e8'}} >Solution</h3>
											<Box style={{marginTop:20}}>
											<span hidden>
												{totalWeightage = 0}
												{(myQuestion.responseChoice && myQuestion.responseChoice.length>0)?myQuestion.responseChoice.map((myRow)=>(totalWeightage+=parseInt(myRow.partMarks))):null}
											</span>
													
											{(myQuestion.responseChoice && myQuestion.responseChoice.length>0 )?myQuestion.responseChoice.map((myRow,i)=>(
												 <Box key={'anss'+i}>
													<span hidden>{qqqPartMarks=Number(((((100/totalWeightage)*myRow.partMarks)/100)*myQuestion.correctAnswerMarks).toFixed(2))}</span>
													<Grid container spacing={2} >
														<Grid item md={10} xs={10} style={{borderBottom: '1px solid gray',padding:10}} >
												 			<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.responseText.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
														</Grid>
														 <Grid item md={2} xs={2} style={{borderBottom: '1px solid gray', borderLeft: '2px solid gray', fontSize: 15, fontWeight:'bold'}} >
														 {/* ##{myRow.partMarks} */}
															 {qqqPartMarks}
															 {testSet[0].testStatus===1?<>															 	
																	{chkedIcon(i,myQuestion.questionId)>0?
																		<CheckBoxIcon style={{fontSize:14,color:'#0158dc'}} />
																		:<CheckBoxOutlineBlankIcon style={{fontSize:14}} />}																
															 </>:
															 <input type="checkbox" id={"option"+myQuestion.questionId+"a"+i} onChange={(event)=>{giveMarks(myQuestion.questionId,myQuestion.correctAnswerMarks,"partmarks"+myQuestion.questionId+"a"+i)}} />
															 }
															<input type="hidden" id={"partmarks"+myQuestion.questionId+"a"+i} value={qqqPartMarks} />
														 </Grid>
													</Grid>	
												 </Box>
											 ))												
											:null}
											</Box>
										</Grid>
									</Grid>								
						</Box>


				</Box>
		))}
		</Box>	
		:null}		

				
							

	</>:null}
	</Box>

	{(testSet[0] && testSet[0]!=null && testSet[0].questionSet)?									
				<Box className='bottomBoxFixedA' >
						<Grid container >
							<Grid item md={12} xs={12} className="textButtonBox" >
								{testSet[0].testStatus===1?<>								
								<Button title="Print" variant="contained" onClick={() => {print()}} style={{backgroundColor:'#595757',color:'#FFFFFF'}} >Print</Button>
								<Button title="Help" variant="contained" onClick={() => {openHelp()}} color="secondary" >Help</Button>
								<DialogFeedback currentQuestionObj={currentQuestionObj} />
								</>:finishTestLoading?
									<LoadingButton loading={finishTestLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#008000',color:'#FFFFFF'}}  variant="contained" >Wait</LoadingButton>
									:<Button onClick={() => { finishTest() }} variant="contained" style={{backgroundColor:'#008000',color:'#FFFFFF'}} >Finish Test Now</Button>
								}
								
								<Button title="Back to Reports" variant="contained" onClick={() => {backToReports()}} style={{backgroundColor:'#dd8313',color:'#FFF'}} >Exit</Button>
								{currentQuestion>0?<Button title="Previous" variant="contained" onClick={() => { backHandle() }} color="primary" >Back</Button>:null}
								<Button title="Save & Next" variant="contained" onClick={() => { nextHandle() }} color="primary" >Next</Button>
								
							</Grid>

						</Grid>
				</Box>
	:null}			

			<DialogHelp toCallStartTimer={() => {}} ref={openHelpRef} currentQuestionObj={currentQuestionObj} />

								
			{/* OUTER BOX PRINT CONTENT START */}
			{testSet && testSet[0] && testSet[0].testStatus===1?<>
			<iframe id="ifmcontentstoprint" hidden ></iframe>
			<div id="printcontents" hidden >
			{/* INNER BOX PRINT CONTENT START */}
					{(testSet[0] && testSet[0]!=null && testSet[0].questionSet)?<>		
								<Box mt={1} className="noselect" >
										<Grid container spacing={2}>
											<Grid item md={12} xs={12}>
											{testSet[0]?<span className='test-name' >{testSet[0].testName}</span>:null}
											</Grid>				
										</Grid>
								</Box>

						{(testSet[0] && testSet[0].questionSet)?	
						<Box>	
						{testSet[0].questionSet.map((myQuestion,myqnum) => (
								<Box key={'qes'+myqnum} className="noselect" >
										<Box spacing={2}>
										<Grid container spacing={2} >
											<Grid item md={12} xs={12} className="questionBox" >
												{(myQuestion.commonDataDescription && myQuestion.commonDataDescription.length>0)?<p className="preWrap animate-zoom" >
													{
														<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.commonDataDescription.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
													}
												</p>:null}
												<p className="preWrap" >
												<span className="questionNum" style={{color:'#FF0000',fontWeight:'bold'}} >Question {myqnum+1}: </span> 
												{(myQuestion.questionBody && myQuestion.questionBody.length>0)?<span>
													{
														<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myQuestion.questionBody.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
													}
												</span>:null}										
												</p>
												{
													myQuestion.columns?
													<p>
														<table width="100%">
															<tr>
																{
																	myQuestion.columns.map((myRow,index) => (	
																		<td className="btmbdrgry pdlft10"><h3>{myRow.columnHeader}</h3></td>
																	))		
																}
															</tr>	
																<tr>
																{myQuestion.columns.map((myCol,indexCol) => (
																	<td><table width="100%">{
																		myCol.columnRows.map((myRow,indexrrr) => (
																			<tr>
																			<td key={'crwq'+indexrrr+'dd'+indexCol} className="btmbdrgry pdlft10 content-justify preWrap" >
																				{myRow.rowId}.&nbsp;
																				{(myRow.rowName && myRow.rowName.length>0)?
																					<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.rowName.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
																				:null														
																				}
																				</td>
																			</tr>
																		))
																		}</table>
																	</td>
																))}
																</tr>
														</table>
													</p>
													:null
												}

											</Grid>
										</Grid>
										</Box>

										<Box >
													<Grid container spacing={2} >										
														<Grid item  xs={12} style={{border: '2px solid gray'}} >
															<h3 style={{textAlign:'center',borderBottom: '2px solid gray',color:'#1572e8'}} >Solution</h3>
															<Box style={{marginTop:20}}>
															<span hidden>
																{totalWeightage = 0}
																{(myQuestion.correctResponse && myQuestion.correctResponse.length>0 && JSON.parse(myQuestion.correctResponse).length>0)?JSON.parse(myQuestion.correctResponse).map((myRow)=>(totalWeightage+=parseInt(myRow.partMarks))):null}
															</span>

															{(myQuestion.correctResponse && myQuestion.correctResponse.length>0 && JSON.parse(myQuestion.correctResponse).length>0)?JSON.parse(myQuestion.correctResponse).map((myRow,i)=>(
																<Box key={'anss'+i}>
																	<span hidden>{qqqPartMarks=Number(((((100/totalWeightage)*myRow.partMarks)/100)*myQuestion.correctAnswerMarks).toFixed(2))}</span>
																	<Grid container spacing={2} >
																		<Grid item xs={12} style={{borderBottom: '1px solid gray',padding:10}} >
																			<MathJaxContext version={3} config={config}><div dangerouslySetInnerHTML={{ __html: myRow.mattext.trim().replace(/[\r\n]+/g, '') }} /></MathJaxContext>									
																		</Grid>														 
																	</Grid>	
																</Box>
															))												
															:null}
															</Box>
														</Grid>
													</Grid>								
										</Box>


								</Box>
						))}
						</Box>	
						:null}
					</>:null}
			{/* INNER BOX PRINT CONTENT END */}
			</div>					
			</>:null}
			{/* OUTER BOX PRINT CONTENT END */}

			</div>


	);
 
}




